import { getConnectionInfo, } from "@helpers";
import { abi, } from ".";
import { isAddress, } from "@types";
import {
	lookupContract,
	lookupToken,
	type TokenDefinition,
} from "@bracket/addressbook";



/** get the rate of an ExECUTABLE token */
export const getRate = (token: TokenDefinition,): any => {

	try {

		const { chain, } = getConnectionInfo();
		const address = lookupContract(1, "EscrowPricing");
		const tokenAddress = lookupToken(1, token.label as any);
		if (isAddress(address)) {
			if (isAddress(tokenAddress)) {

				const result = {
					address,
					abi,
					functionName: "getRate",
					args: [tokenAddress,],
					chainId: 1,
				}

				const log = [
					"--- IBracketOracle::getRate ---",
					"chain: 1",
					`currency: ${token.symbol}`,
					`contract address: ${result.address}`,
					`functionName: ${result.functionName}`,
					"args:",
					`\t0 [tokenAddress]: ${result.args[0]}`,
					"----------",
				];

				return result;

			}
			throw new Error(`failed gaining token address for "${token}" on chain ${chain}.`);
		}
		throw new Error(`failed gaining ewcrow pricing contract address for chain ${chain}.`);
	} catch (err) {
		throw new Error(`contracts.BracketOracle.getRate - ${err instanceof Error ? err.message : "no error was produced."}`);
	}

}
